import { useEffect, useState } from "react";
import { safeFetch } from "../lib/safeFetch";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Fallback defaults — used ONLY if the API is unreachable so the site never breaks.
// Kept minimal (labels + routes + icons from CDN). These mirror the original hardcoded SIDE_MENU.
const CDN = "https://img.b112j.com/bj/h5/assets/v3/images/icon-set/menu-type/active";
const FALLBACK_PRIMARY = [
  { id: "exclusive", slug: "exclusive", label: "Exclusive Games", icon: `${CDN}/icon-logo.png`, to: "/", order: 0, enabled: true, kind: "primary" },
  { id: "sports",    slug: "sports",    label: "Sports",          icon: `${CDN}/icon-sport.png`,   to: "/sports",  order: 1, enabled: true, kind: "primary" },
  { id: "casino",    slug: "casino",    label: "Casino",          icon: `${CDN}/icon-casino.png`,  to: "/casino",  order: 2, enabled: true, kind: "primary" },
  { id: "slots",     slug: "slots",     label: "Slots",           icon: `${CDN}/icon-slot.png`,    to: "/slots",   order: 3, enabled: true, kind: "primary" },
  { id: "crash",     slug: "crash",     label: "Crash",           icon: `${CDN}/icon-crash.png`,   to: "/crash",   order: 4, enabled: true, kind: "primary" },
  { id: "table",     slug: "table",     label: "Table",           icon: `${CDN}/icon-table.png`,   to: "/table",   order: 5, enabled: true, kind: "primary" },
  { id: "fishing",   slug: "fishing",   label: "Fishing",         icon: `${CDN}/icon-fish.png`,    to: "/fishing", order: 6, enabled: true, kind: "primary" },
  { id: "favourite", slug: "favourite", label: "Favourite",       icon: "",                        to: "/favourite", order: 7, enabled: true, kind: "primary" },
  { id: "lottery",   slug: "lottery",   label: "Lottery",         icon: `${CDN}/icon-lottery.png`, to: "/lottery", order: 8, enabled: true, kind: "primary" },
];
const FALLBACK_SECONDARY = [
  { id: "promotions", slug: "promotions", label: "Promotions",       to: "/promotions",  order: 0, enabled: true, kind: "secondary", icon: "" },
  { id: "vip",        slug: "vip",        label: "VIP Club",         to: "/vip",         order: 1, enabled: true, kind: "secondary", icon: "" },
  { id: "referral",   slug: "referral",   label: "Referral program", to: "/referral",    order: 2, enabled: true, kind: "secondary", icon: "" },
  { id: "affiliate",  slug: "affiliate",  label: "Affiliate",        to: "/profile/affiliate",     order: 3, enabled: true, kind: "secondary", icon: "" },
  { id: "ambassador", slug: "ambassador", label: "Brand Ambassadors",to: "/ambassadors", order: 4, enabled: true, kind: "secondary", icon: "" },
  { id: "app",        slug: "app",        label: "APP Download",     to: "/app-download",order: 5, enabled: true, kind: "secondary", icon: "" },
  { id: "contact",    slug: "contact",    label: "Contact Us",       to: "/contact",     order: 6, enabled: true, kind: "secondary", icon: "" },
];

// simple in-memory cache so sidebar + side menu share one fetch
let _cache = null;
let _pending = null;

export function useSiteCategories() {
  const [state, setState] = useState(
    _cache || { primary: FALLBACK_PRIMARY, secondary: FALLBACK_SECONDARY, loading: !_cache }
  );

  useEffect(() => {
    if (_cache) return;
    if (!_pending) {
      _pending = safeFetch(`${BACKEND_URL}/api/public/categories`)
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (data && Array.isArray(data.primary)) {
            _cache = {
              primary: data.primary.length ? data.primary : FALLBACK_PRIMARY,
              secondary: data.secondary && data.secondary.length ? data.secondary : FALLBACK_SECONDARY,
              loading: false,
            };
          } else {
            _cache = { primary: FALLBACK_PRIMARY, secondary: FALLBACK_SECONDARY, loading: false };
          }
          return _cache;
        })
        .catch(() => {
          _cache = { primary: FALLBACK_PRIMARY, secondary: FALLBACK_SECONDARY, loading: false };
          return _cache;
        });
    }
    _pending.then((c) => setState(c));
  }, []);

  return state;
}
